export default __webpack_public_path__ + "static/media/pic2.0a015709.jpg";